import { render, staticRenderFns } from "./TeamDetailsPopup.vue?vue&type=template&id=41b6fdc5"
import script from "./TeamDetailsPopup.vue?vue&type=script&lang=js"
export * from "./TeamDetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports